import * as React from 'react';
import { GetAccountInfoQuery } from '@websky/graphql';

interface Props {
	userInfo?: GetAccountInfoQuery['CurrentUser'];
	refetchUser?: () => Promise<GetAccountInfoQuery>;
}

const ServicesAggregationContext = React.createContext<Props>(null!);

export function getServicesAggregation() {
	return React.useContext(ServicesAggregationContext);
}

const ServicesAggregationProvider: React.FC<Props> = ({ children, userInfo, refetchUser }) => {
	return (
		<ServicesAggregationContext.Provider value={{ userInfo, refetchUser }}>
			{children}
		</ServicesAggregationContext.Provider>
	);
};

export default ServicesAggregationProvider;
